export enum ShippingProvider {
  EVRI = 'evri',
  DHL = 'dhl',
  DPD = 'dpd',
  MANUAL = 'manual',
}

export enum AddressType {
  RESIDENTIAL = 'residential',
  DPD = 'dpd',
}
